var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 488 488",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.9,666.06c0-0.1-0.1-0.3-0.1-0.4c0-0.2-0.1-0.3-0.1-0.5c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.2-0.1-0.3-0.2-0.5 c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.2-0.5-0.4-0.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.1-0.1-0.2-0.2-0.3 c-0.1-0.1-0.1-0.2-0.2-0.3l-90-117.4l-0.1-0.1c-0.2-0.2-0.3-0.4-0.5-0.6c-0.1-0.1-0.1-0.2-0.2-0.2c-0.2-0.3-0.5-0.5-0.8-0.7 c0,0,0,0-0.1-0.1c-0.3-0.2-0.5-0.4-0.8-0.6c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.3-0.7-0.4c-0.1,0-0.2-0.1-0.3-0.1 c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.3-0.1-0.5-0.1-0.8-0.1 c-0.1,0-0.2,0-0.3,0c-0.4,0-0.7-0.1-1.1-0.1H49c-5.5,0-10,4.5-10,10v468c0,5.5,4.5,10,10,10h390c5.5,0,10-4.5,10-10v-350.6 c0-0.2,0-0.5,0-0.8v0c0-0.1,0-0.2,0-0.3C449,666.46,448.9,666.26,448.9,666.06z M418.7,657.86h-59.5l-0.2-77.8L418.7,657.86z  M429,1008.46H59v-448h280l0.2,107.4c0,5.5,4.5,10,10,10H429V1008.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3,723.46c0,5.5,4.5,10,10,10h266.2c5.5,0,10-4.5,10-10s-4.5-10-10-10H111.3C105.8,713.46,101.3,717.96,101.3,723.46 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,672.46h173.8c5.5,0,10-4.5,10-10s-4.5-10-10-10H111.4c-5.5,0-10,4.5-10,10S105.9,672.46,111.4,672.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,794.46h266.2c5.5,0,10-4.5,10-10s-4.5-10-10-10H111.3c-5.5,0-10,4.5-10,10S105.8,794.46,111.3,794.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,835.46H111.4c-5.5,0-10,4.5-10,10s4.5,10,10,10h173.8c5.5,0,10-4.5,10-10S290.7,835.46,285.2,835.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,931.96l28.6-28.3c3.9-3.9,4-10.2,0.1-14.1c-3.9-3.9-10.2-4-14.1-0.1l-28.7,28.5l-28.7-28.5 c-3.9-3.9-10.3-3.9-14.1,0.1c-3.9,3.9-3.9,10.3,0.1,14.1l28.6,28.3l-28.6,28.3c-3.9,3.9-4,10.2-0.1,14.1c2,2,4.5,3,7.1,3 c2.5,0,5.1-1,7-2.9l28.7-28.5l28.7,28.5c1.9,1.9,4.5,2.9,7,2.9c2.6,0,5.1-1,7.1-3c3.9-3.9,3.9-10.3-0.1-14.1L355.9,931.96z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/accessDenied.0292d80f829f49d18636208f8bc23031.svg";
export { ForwardRef as ReactComponent };